import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import enTranslation from "./locales/en/en.json"
import csTranslation from "./locales/cs/cs.json"

export const languages = {
  en: { nativeName: "English", workingName: "en" },
  cs: { nativeName: "Čeština", workingName: "cs" },
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: "true",
    fallbackLng: "en",
    resources: {
      en: {
        translation: enTranslation,
      },
      cs: {
        translation: csTranslation,
      },
    },
  })
